import Icon from "components/Icon"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import richText from "utilities/richText"

function Item({ item }) {
  return (
    <StoryblokVisualEditor story={item}>
      <div className="basis-1/2">
        <Icon icon={item.icon} className="mb-4" />
        <h3 className="pb-5 font-secondary font-medium text-teal-dark">{item.title}</h3>
        <div>{richText(item.content)}</div>
      </div>
    </StoryblokVisualEditor>
  )
}

export default function ProgramOverview({ blok }) {
  return (
    <section className="program-overview relative bg-springWood px-6 py-16">
      <div className="mx-auto max-w-screen-xl">
        <h2 className="program-overview-heading pb-6 text-teal-dark lg:pb-10">{blok.heading}</h2>
        <div className="flex flex-col gap-6 lg:flex-row lg:gap-16">
          {blok?.items?.map((item) => (
            <Item item={item} key={item._uid} />
          ))}
        </div>
      </div>
    </section>
  )
}
